import { css } from "styled-components";
import { buildRulesets } from "./buildRulesets";
import "../designTokens/variables.css";

const fontFamily = css`
  font-family: "Nunito Sans", "Nunito", var(--font-family-alpha);
`;

const textStyleToSizeMapping = {
  headline1: css`
    font-weight: var(--font-weight-light);
    font-size: 51px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  headline2: css`
    font-weight: var(--font-weight-semibold);
    font-size: 26px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  headline3: css`
    font-weight: var(--font-weight-regular);
    font-size: 26px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  subtitle1: css`
    font-weight: var(--font-weight-semibold);
    font-size: 17px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  subtitle2: css`
    font-weight: var(--font-weight-regular);
    font-size: 17px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  subtitle3: css`
    font-weight: var(--font-weight-semibold);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
  `,
  body1: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
  `,
  body2: css`
    font-weight: var(--font-weight-extrabold);
    font-size: 13px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  body3: css`
    font-weight: var(--font-weight-bold);
    font-size: 13px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  body4: css`
    font-weight: var(--font-weight-semibold);
    font-size: 13px;
    letter-spacing: var(--letter-spacing-normal);
  `,
  caption: css`
    font-weight: var(--font-weight-bold);
    font-size: 11px;
    letter-spacing: var(--letter-spacing-normal);
  `,
};

const rulesets = buildRulesets({ fontFamily, textStyleToSizeMapping });

export const {
  primaryActive,
  primaryInactive,
  primaryDisabled,
  link,
  warning,
  error,
  success,
  whiteActive,
  whiteInactive,
  whiteDisabled,
} = rulesets;
